import { API } from "@/services"
import { DATA_CENTER_ENDPOINTS } from "./data-center"

export const NETWORK_ENDPOINTS = {
  data_center: DATA_CENTER_ENDPOINTS,
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `network`,
      method: 'POST',
      data,
    })
  },
  list(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `network`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${id}`,
      method: 'PUT',
      data,
    })
  },
}